import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  FadvComponentsModule,
  FadvStepperModule,
  FadvAlertModule,
  FadvApplicationModule,
  FadvBoxModule,
  FadvButtonModule,
  FadvCardModule,
  FadvGridModule,
  FadvLayoutModule,
  FadvTypographyModule,
  FadvCommonModule,
  FadvInputModule
} from '@fa-switch-sharedservices/ng-elements';
import { CampaignRoutingModule } from './campaign-routing.module';
import { FreeBackgroundAuthComponent } from './free-background-auth/free-background-auth.component';
import { FreeBackgroundComponent } from './free-background-landing/free-background.component';
import { CampaignComponent } from './campaign.component';
import { AlertMessageModule } from '../alert-message/alert-message.module';

@NgModule({
  declarations: [FreeBackgroundAuthComponent, FreeBackgroundComponent, CampaignComponent],
  imports: [
    CommonModule,
    CampaignRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    FadvComponentsModule,
    FadvCardModule,
    FadvStepperModule,
    FadvCommonModule,
    FadvApplicationModule,
    FadvAlertModule,
    FadvLayoutModule,
    FadvGridModule,
    FadvInputModule,
    FadvButtonModule,
    FadvBoxModule,
    FadvTypographyModule,
    AlertMessageModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CampaignModule { }
